export default {
  name: 'AcheckboxGroup',
  props: {
    value: { type: null, default: () => null },
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
  },
  data() {
    return {
      model: this.value,
    }
  },
  watch: {
    value(value) {
      this.model = value;
    }
  },
  computed: {
    array() {
      return this.options || this.option || this.config || this.items || this.data || [];
    },
    smart() {
      const a = this.$attrs;
      const smart = (a.shortcuts || a.shortcut || a.quickly || a.quick || a.smart || a.fast || a.all);
      return smart !== undefined ? smart : true;
    },
    checked: {
      get() { return this.value && ((this.value.length > 0) && (this.value.length === this.array.length)) },
      set(value) { this.$emit('update:checked', value) },
    },
    indeterminate() {
      return this.value && ((this.value.length > 0) && (this.value.length !== this.array.length));
    },
  },
  methods: {
    input(value) {
      this.$emit('input', value);
    },
    change(value = null) {
      this.$emit('change', value, this.filter(value));
    },
    choose(checked) {
      const data = [];
      if (checked) {
        this.data.forEach((a, b) => data[b] = (`${a.values || a.value || a.code || a.val || a.id || a}`));
        this.change(data);
      }
      this.model = data;
      this.$emit('input', data);
    },
    filter(value = '') {
      if (value && value !== '') {
        let data = {};
        this.array.forEach(a => {
          const index = (`${a.values || a.value || a.code || a.val || a.id || a}`);
          if (value === index) data = a;
        });
        return data;
      }
    },
  },
  render() {
    const { ...attrs } = this.$attrs;
    return this.array.length > 0 && (
      <div class="a-checkbox-group">
        {this.smart && (<el-checkbox v-model={this.checked} indeterminate={this.indeterminate} on-change={this.choose}>全部</el-checkbox>)}
        <el-checkbox-group v-model={this.model} on-input={this.input} on-change={this.change} on={this.$listeners}  {...{ attrs }}>
          {this.array.map((a, b) => {
            const label = a.label || a.title || a.text || a.name || a.key || a;
            const value = (`${a.value || a.code || a.val || a.id || a}`);
            return (<el-checkbox key={b} label={value}>{label}</el-checkbox>);
          })}
        </el-checkbox-group>
      </div>
    );
  }
}